const common = require('./common');
const components = require('./components/index');
const pages = require('./pages');

module.exports = {
  common,
  components,
  pages,
};
